import React from 'react';
import { useFormikContext } from 'formik';
import { useTranslator } from '@front-activerse/common-components';
import { goalSettings } from '../types';

export const Summary: React.FC = () => {
  const { t } = useTranslator();
  const { values } = useFormikContext<goalSettings>();
  const {
    weightValue,
    weightUnit,
    dietMode,
    goalWeightValue,
    spontaneousActivityLevel,
    activityLevel,
  } = values;

  const decimalSeparator = () => {
    const n = 1.1;
    const separator = n.toLocaleString().substring(1, 2);
    return separator;
  };

  return (
    <>
      <h2 className="mb-m title-large semi-bold">{t('goalSettings.summary.headline')}</h2>
      <p className="mb-xl text-text-variant-color">{t('goalSettings.summary.description')}</p>
      <div>
        <dl>
          <dt>{t('app.goalSettings.summary.list.currentWeight')}</dt>
          <dd>
            {String(weightValue).replace('.', decimalSeparator())} {weightUnit}
          </dd>
        </dl>

        <dl>
          <dt>{t('app.goalSettings.summary.list.goal')}</dt>
          <dd>{t(`app.goalSettings.summary.list.goal.${dietMode}`)}</dd>
        </dl>

        {dietMode !== 'stabilization' && (
          <dl>
            <dt>{t('app.goalSettings.summary.list.goalWeight')}</dt>
            <dd>
              {String(goalWeightValue).replace('.', decimalSeparator())} {weightUnit}
            </dd>
          </dl>
        )}

        <dl>
          <dt>{t('settings.goalSettings.list.spontaneousActivity')}</dt>
          <dd>
            {t(`app.goalSettings.summary.list.spontaneousActivity.${spontaneousActivityLevel}`)}
          </dd>
        </dl>

        <dl>
          <dt>{t('settings.goalSettings.list.activity')}</dt>
          <dd>{t(`app.goalSettings.summary.list.activity.${activityLevel}`)}</dd>
        </dl>
      </div>
    </>
  );
};

export default Summary;
